import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IAddRoleActionRequest {
  roleId: [number]; 
  microServiceName: string;
  controllerName: string;
  actionName: string;
  canCall: boolean;
}

async function addRoleAction(data: IAddRoleActionRequest): Promise<any> {
  try {
    return (await axiosInstance.post("/RoleAction/Add", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useAddRoleAction() {
  return useMutation<any, Error, IAddRoleActionRequest>((variables) =>
  addRoleAction(variables)
  );
}
